import * as React from 'react';

import { FormSections, ProgramContainer } from '../entities/formTemplateDataType';

import { MenuComponent } from './MenuComponent';

import { FormPreviewComponent } from './FormPreviewComponent';
import { FormDesignComponent } from './FormDesignComponent';
import { UploadComponent } from './UploadComponent';
import axios from 'axios';
import URLUtils from '../utilities/URLUtils';
import { Toast } from 'primereact/toast';
import DataUtils from '../utilities/DataUtils';
import LoadingOverlay from 'react-loading-overlay';

import ReactDOMServer from 'react-dom/server';
import html2pdf from 'html2pdf.js';
import LocalStorageService from '../services/SessionStorageService';
import { SummaryComponent } from '../runtimeComponent/subComponent/SummaryComponent';
// import { parseJson, stringifyJson } from '../utilities/JsonUtils';
import * as CircularJSON from 'circular-json';
import { TOKEN_TYPE } from '../entities/Constants';

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    // user: User,
    hash,
    callback: (programContainer: ProgramContainer) => void;
    callbackOriginalData;
}

interface State {
    // user: User;
    toggleState,
    isEng: boolean,
    dialogVisible: boolean,
    orginalEntity,
    isBusy: boolean,
    hideValidationPanel: boolean,
}

export class DetailFormComponent extends React.Component<Props, State> {

    formSectionsList;
    programContainer;
    growl: Toast;
    errorMessages: string[] = [];
    validationErrorString: any = [];

    constructor(props: Props) {
        super(props);

        let programContainer = this.props.programContainer

        if (this.props.programContainer == null) {
            programContainer = new ProgramContainer();
            this.formSectionsList = new Array<FormSections>();
            programContainer.ListOfFormSections = this.formSectionsList;
        }

        this.state = {
            // user: this.props.user,
            orginalEntity: {},
            toggleState: {
                displayDesign: process.env.IS_RUNTIME === "false",
                displayPreview: process.env.IS_RUNTIME === "true",
                displayPublish: false,
                displaySave: false,
                displayDownload: false
            },
            isEng: true,
            dialogVisible: false,
            isBusy: false,
            hideValidationPanel: true
        };
    }

    render() {
        let htmlString = [];
        htmlString.push(
            <div style={{ display: 'flex', justifyContent: 'flex-space' }}>
                <div>
                    <MenuComponent
                        callback={(state) => {
                            if (state.displayDownload) {
                                this.download();
                            } else if (state.displayDownloadPayload) {
                                this.downloadPayload();
                            } else if (state.displayDownloadPDF) {
                                this.downloadPDF();
                            }
                            else if (state.displayUpload) {
                                let toggleState = {
                                    displayDesign: false,
                                    displayPreview: false,
                                    displayPublish: false,
                                    displaySave: false,
                                    displayDownload: false,
                                    displayUpload: true,
                                };

                                this.setState({ toggleState: toggleState })
                            } else if (state.displaySave) {
                                const categoryId = this.props.programContainer.CategoryId;
                                const categoryName = this.props.programContainer.Name;
                                const userId = LocalStorageService.getUserId().toLowerCase();
                                const isCoowner = this.props.programContainer.Coowners?.filter(coowner => coowner.email.toLowerCase() == userId)?.length > 0;
                                

                                if (isCoowner ||this.props.programContainer.createdById.toLowerCase() == userId) {
                                    this.saveLayout();
                                }
                                else if (this.props.programContainer.Deployed) {
                                    this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'The form has been deployed to production thus it is not allowed to be changed by the users other than the creator' });
                                } else {
                                    let api = URLUtils.concatUrls('data/admin/form/' + this.props.programContainer.id);
                                    const token = LocalStorageService.getAccessToken(TOKEN_TYPE.API);
                                    const headers = {
                                        'Authorization': `Bearer ${token}`
                                    }
                                    axios.get(api, { headers: headers })
                                        .then((response) => {
                                            let coowners = CircularJSON.parse(response.data.attachment).Coowners;
                                            let userIsCoowners = coowners && coowners.length > 0 && coowners.reduce((acc, user) => acc || (userId.toLowerCase() == String(user.userName).toLowerCase()), false);
                                            if (userIsCoowners) { this.saveLayout() }
                                            else {
                                                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'You do not have permission to change this form' });
                                            }
                                        })
                                        .catch((message) => {
                                            console.log(message);
                                            this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Save failed' });
                                        });
                                }

                            } else if (state.displaySubmit) {
                                this.saveSubmit();
                            } else if (state.displayPublish) {


                            } else {
                                this.setState({ toggleState: state });
                            }
                        }}></MenuComponent>
                </div>

                <div style={{ display: this.state.toggleState.displayUpload == true ? 'block' : 'none', width: '80%' }}>
                    <UploadComponent
                        callback={(programContainer) => {
                            this.props.callback(programContainer);
                        }} />
                </div>

                <div style={{ display: this.state.toggleState.displayDesign == true ? 'block' : 'none', width: '80%' }}>
                    <FormDesignComponent
                        isEng={this.state.isEng}
                        programContainer={this.props.programContainer}
                        dialogVisible={this.state.dialogVisible}
                        callback={programContainer => this.props.callback(programContainer)}
                        callBackLang={isEng => this.setState({ isEng: isEng })}
                    />
                </div>

                <div style={{ display: this.state.toggleState.displayPreview ? 'block' : 'none', width: '80%' }}>
                    {!this.state.hideValidationPanel && this.validationErrorString}
                    <FormPreviewComponent
                        isEng={this.state.isEng}
                        hash={this.props.hash}
                        programContainer={this.props.programContainer}
                        callbackOriginalData={orginalEntity => { this.setState({ orginalEntity: orginalEntity }) }}
                        callback={para => this.props.callback(para)}
                        callBackLang={isEng => this.setState({ isEng: isEng })} />
                </div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} >
                        <LoadingOverlay active={this.state.isBusy} overlayColor="rgba(0,153,255,0.2)" />
                    </div>
                </div>
            </div>

        )

        htmlString.push(
            <>
                {/* @ts-ignore */}
                <Toast ref={(el) => this.growl = el} />
            </>
        )
        return htmlString;
    }


    saveLayout = () => {
        let api = "data/admin/save";
        let entity;
        this.setState({ isBusy: true });
        if (process.env.IS_RUNTIME == 'false') {
            DataUtils.clearFormValue(this.props.programContainer);
            console.log(this.props.programContainer)

            delete this.props.programContainer.CMAOptionList;
            delete this.props.programContainer.CMATemplateList;
            delete this.props.programContainer.CategoryNameList;
            delete this.props.programContainer.ClusterOptions;
            delete this.props.programContainer.FunctionNameList;
            delete this.props.programContainer.MinistryOptions;
            delete this.props.programContainer.OrganizationList;
            delete this.props.programContainer.SectorOptions;
            delete this.props.programContainer.SubCategoryNameList;

            console.log(this.props.programContainer)
            
            let content = CircularJSON.stringify(this.props.programContainer);

            entity = {
                id: this.props.programContainer.id,
                categoryName: this.props.programContainer.Name,
                formType: 'Form',
                attachment: content,
                categoryId: this.props.programContainer.CategoryId,
            }
        } else {
            let caseId = this.props.hash.match("(?<=&caseId\=)(.*)");
            api = "data/case/save";
            let values = DataUtils.collectFormValue(this.props.programContainer);

            entity = {
                caseId: caseId[0],
                id: this.props.programContainer.id,
                formValue: values,
            }
        }

        // let userToken = LocalStorageService.getAccessToken();

        // if (process.env.ENV == 'local') {
        //     axios.post(URLUtils.concatUrls(api), entity, { withCredentials: true })                .then((result) => {
        //             this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Form saved' });
        //             this.setState({ isBusy: false });
        //             let programContainer = CircularJSON.parse(result.data.attachment);
        //             programContainer.id = result.data.id;
        //             this.props.callback(programContainer);
        //         }
        //         )
        // } else {
        let token = LocalStorageService.getAccessToken(TOKEN_TYPE.API);
        if(!token){
            this.growl.show({ severity: 'error', summary: 'Please refresh the application', detail: "Too long inactivity"});
            return;
        }
         const headers = {
            'Authorization': `Bearer ${token}`
        }
               
        axios.post(URLUtils.concatUrls(api), entity, { headers: headers })
            .then((result) => {
                this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Form saved' });
                this.setState({ isBusy: false });
                let programContainer = CircularJSON.parse(result.data.attachment);
                programContainer.id = result.data.id;
                this.props.callback(programContainer);
            })
            .catch((error) => {
                console.log(error);
                const resBody = error.response?.data;
                if (resBody?.message == "Data input is not valid") {
                    for (const e of resBody.errors) {
                        this.growl.show({ severity: 'error', summary: 'Error Message', detail: e.split(':')[1]});
                    }
                } else {
                    for (const e of resBody?.errors) {
                        if (e.includes("UC_Category_id")) {
                            this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Application ID must be unique'});
                        } else {
                            this.growl.show({ severity: 'error', summary: 'Error Message', detail: e});
                        }
                    }
                }
            })
        // }
    }

    saveSubmit = () => {
        let hash = this.props.hash;
        if (hash == null || hash == '') return null;
        let categoryId;

        let pattern = /categoryId=([^&]+)&caseId=([^&]+)/;
        if (hash.indexOf('language') > -1) {
            pattern = /categoryId=([^&]+)&caseId=([^&]+)&language=([^&]+)/;
        }
        const matches = hash.match(pattern);
        let caseId;
        if (matches) {
            caseId = matches[2];
        }
        if (caseId) {
            let api = this.props.programContainer.UpdateAPI;
            let caseObject = DataUtils.collectFormValue(this.props.programContainer, 'Y');
            caseObject["operation"] = "upsert";
            caseObject["Id"] = caseId;
            // caseObject["Id"] = this.state.orginalEntity.SiebelMessage.HLSCase.Id;
            let containerName = "ListOf" + this.props.programContainer.IntObjectName;
            let SiebelObject = {
                "SiebelMessage": {
                    "MessageId": this.state.orginalEntity.SiebelMessage.MessageId,
                    "MessageType": this.state.orginalEntity.SiebelMessage.MessageType,
                    "IntObjectName": this.props.programContainer.IntObjectName,
                    "IntObjectFormat": this.state.orginalEntity.SiebelMessage.IntObjectFormat,
                }
            };

            SiebelObject.SiebelMessage[containerName] = {
                "HLSCase": caseObject
            }

            let fullApiUrl = URLUtils.concatUrls("data/tpon/transfer");
            let body = { "body": SiebelObject }
            let transferUrl = this.props.programContainer.APIBasePath + api;
            let httpMethod = "POST";
            let tponTransferDto = { httpMethod: httpMethod, url: transferUrl, payload: body }

            // let script = "this.errorMessages.push('Hi');"
            // eval(script);
            //get all Scripts to execute
            //   this.executeValidationScript();
            //all script generated errors are pushed to this.errorMessages
            if (this.errorMessages.length == 0) {
                this.setState({ isBusy: true });
                axios.post(fullApiUrl, tponTransferDto, { withCredentials: true })
                    .then((response) => {
                        this.setState({ isBusy: false });
                        this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Form submitted successfully' });
                        //return always has SiebelMessage.HLSCase to begin with 
                        // DataUtils.assignFormValue(this.programContainer, response.data.SiebelMessage.HLSCase);
                    })
            }
        }
    }

    //Download pdf html2pdf version
    downloadPDF = () => {
        const pdfJSX = () => {
            return (
                <div style={{ display: "block : none", margin: "25px 15px" }}>
                    {<SummaryComponent programContainer={this.programContainer} isEng={this.props.isEng}></SummaryComponent>}
                </div>
            )
        }
        const printElement = ReactDOMServer.renderToString(pdfJSX());
        html2pdf().from(printElement).save("summaryPdf.pdf");
    }

    download = () => {
        let contentCloned: ProgramContainer = CircularJSON.parse(CircularJSON.stringify(this.props.programContainer));
        contentCloned.ListOfFormSections.forEach(section => {
            section.ListOfFormSubSections.forEach(subSection => {
                subSection.ListOfFormSectionElements.forEach(ele => {
                    if (ele.Datatype != 'Label' && ele.Datatype!='TechError')
                        ele.Value = null;
                    ele.day = null;
                    ele.month = null;
                    ele.year = null;
                })
            })
        })
        contentCloned.Entity=null;
        contentCloned.createdById="";
        contentCloned.Coowners=[];
        let content = CircularJSON.stringify(contentCloned);

        const blob = new Blob([content], { type: `application/json;charset=utf-8;` });
        const link = document.createElement('a');
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'configForm.json');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    downloadPayload = () => {
        let payload = DataUtils.collectFormValue(this.props.programContainer);

        let outputData = CircularJSON.stringify(payload);

        const blob = new Blob([outputData], { type: `application/json;charset=utf-8;` });
        const link = document.createElement('a');
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'payload.json');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

